export default "__VITE_ASSET__L9RH1VJs__"